export default __webpack_public_path__ + "static/media/652.260de422.jpg";